<!--
 * @Author:
 * @Description: 接入配置管理-监控提醒配置
-->
<template>
  <el-card class="h-full" :body-style="{ padding: '10px', height: '100%' }">
    <el-dialog
      v-dialogDrag
      title="监控测点提醒配置"
      :visible.sync="visible"
      class="mid-dialog"
      custom-class="configure-dialog"
      :before-close="closeDialog"
      :close-on-click-modal="false"
    >
      <el-form
        :model="sourceForm"
        :rules="sourceRules"
        label-position="right"
        label-width="150px"
        ref="sourceFormRef"
      >
        <el-form-item prop="enableStatus" label="启用">
          <el-switch
            v-model="sourceForm.enableStatus"
            size="small"
            :inactive-value="0"
            :active-value="1"
            clearable
          ></el-switch>
        </el-form-item>
        <el-form-item prop="smtpIp" label="smtp服务器">
          <el-input v-model="sourceForm.smtpIp" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item prop="smtpPort" label="smtp端口号">
          <el-input v-model="sourceForm.smtpPort" type="number" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item prop="isEncrypt" label="是否加密">
          <el-radio-group v-model="sourceForm.isEncrypt">
            <el-radio :label="0">不加密</el-radio>
            <el-radio :label="1">ssl</el-radio>
            <el-radio :label="2">tls</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="alarmPeriod" label="掉线判断周期">
          <el-input v-model="sourceForm.alarmPeriod" type="number" size="small" clearable>
            <template #append>分</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="emailServerAccount" label="邮件账号">
          <el-input v-model="sourceForm.emailServerAccount" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item prop="emailServerPwd" label="邮件密码">
          <el-input
            v-model="sourceForm.emailServerPwd"
            type="password"
            clearable
            show-password
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item prop="emailClients" label="接收提醒账号1">
          <el-input v-model="sourceForm.emailClients" size="small" clearable>
            <template #append>
              <span @click="addAccount" class="cursor-pointer">添加</span></template
            >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="`接收提醒账号${index + 2}`"
          v-for="(item, index) in reveiveAccountLists"
          :key="index"
          :prop="`emailClients${index + 2}`"
          :rules="[{ type: 'email', trigger: 'blur', message: '请输入正确的邮箱地址' }]"
        >
          <el-input v-model="sourceForm[`emailClients${index + 2}`]" size="small" clearable>
            <template #append>
              <span class="cursor-pointer" @click="deleteAccount(index)">删除</span>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="offlineWarnContent" label="掉线提醒内容">
          <el-input
            v-model="sourceForm.offlineWarnContent"
            type="textarea"
            size="small"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="recoverWarnContent" label="恢复提醒内容">
          <el-input
            v-model="sourceForm.recoverWarnContent"
            type="textarea"
            size="small"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex justify-center">
        <el-button
          size="small"
          type="primary"
          icon="iconfont icon-save"
          :loading="saveLoading"
          @click="save"
          >保存</el-button
        >
        <el-button size="small" icon="iconfont icon-close" @click="closeDialog()">取消</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script type="text/babel">
import configManagementService from '@/services/configManagementService'
import { map } from 'lodash'

export default {
  props: {
    visible: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    rowData: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      stateList: [
        { id: 0, valid: true },
        { id: 1, valid: false },
      ],
      reveiveAccountLists: [],
      saveLoading: false,
      sourceForm: {
        dataSourceName: '', // 数据源名称
        smtpIp: '', // smtpIp 服务器
        smtpPort: '', // smtp端口号
        isEncrypt: 0, // 是否加密
        alarmPeriod: '', // 掉线判断周期
        emailServerAccount: '', // 邮箱账号
        emailServerPwd: '', // 邮箱密码
        recoverWarnContent: '', // 恢复提醒内容
        offlineWarnContent: '', // 掉线提醒内容
        enableStatus: 1, // 1启用、0停止
        emailClients: '', // 接收提醒账号1
      },
      sourceRules: {
        smtpIp: [{ required: true, message: '必填', trigger: 'blur' }],
        smtpPort: [{ required: true, message: '必填', trigger: 'blur' }],
        emailServerAccount: [
          { required: true, message: '必填', trigger: 'blur' },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change'],
          },
        ],
        emailServerPwd: [{ required: true, message: '必填', trigger: 'blur' }],
        alarmPeriod: [{ required: true, message: '必填', trigger: 'blur' }],
        offlineWarnContent: [{ required: true, message: '必填', trigger: 'blur' }],
        recoverWarnContent: [{ required: true, message: '必填', trigger: 'blur' }],
        emailClients: [
          { required: true, message: '必填', trigger: 'blur' },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change'],
          },
        ],
      },
    }
  },
  watch: {},
  computed: {},
  created() {
    this.getEmailMonitorPointDetail()
  },
  methods: {
    // 添加提醒账号
    addAccount() {
      this.reveiveAccountLists.push({
        content: '',
      })
    },
    // 删除提醒账号
    deleteAccount(index) {
      this.reveiveAccountLists.splice(index, 1)
    },
    closeDialog() {
      this.$emit('closeMonitorPointRemindConfigDialog')
    },
    // 保存
    save() {
      console.log(this.sourceForm, 'this.sourceForm')
      this.$refs.sourceFormRef.validate(async (valid) => {
        if (valid) {
          // 处理邮件账号，合并所有emailClients
          const formData = { ...this.sourceForm }
          const emailList = [formData.emailClients]

          // 收集emailClients2到emailClients100的值
          for (let i = 2; i <= 100; i += 1) {
            const key = `emailClients${i}`
            if (formData[key]) {
              emailList.push(formData[key])
              delete formData[key] // 删除额外的emailClients字段
            }
          }

          // 用逗号连接所有邮箱地址
          formData.emailClients = emailList.filter(Boolean).join(',')
          formData.id = this.rowData.id

          this.saveLoading = true
          const result = await configManagementService.saveEmailMonitorPoint(formData)
          this.saveLoading = false
          if (result && result.code === 0) {
            this.$message.success('保存成功')
            this.$emit('closeMonitorPointRemindConfigDialog')
          }
          //   let validEmail = true
          //   const emailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9])+(.[a-zA-Z0-9_-])+/
          //   if (!isEmpty(this.reveiveAccountLists)) {
          //     forEach(this.reveiveAccountLists, (item) => {
          //       if (!emailReg.test(item.content)) {
          //         validEmail = false
          //       }
          //     })
          //   }
        }
      })
    },
    // 获取详情
    async getEmailMonitorPointDetail() {
      const res = await configManagementService.getEmailMonitorPoint(this.rowData.id)
      if (res && res.code === 0) {
        this.sourceForm = res.data || this.$options.data().sourceForm
        // 提醒账号
        this.reveiveAccountLists =
          (res.data &&
            map(res.data.emailClients.slice(1), (item) => {
              return {
                content: item,
              }
            })) ||
          []
      }
    },
  },
}
</script>
<style lang="scss" scoped>

</style>
